export const NUMBER_WIDGET_VALUES = {
  task: 'Tasks & Work Orders',
  scheduledTask: 'Scheduled Tasks',
  submission: 'Submissions',
  flaggedItems: 'Flagged Items',
};
